var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp-badge"},[_c('PagContainer',{staticClass:"pag-canvas badge-canvas",class:("badge-" + _vm.station),attrs:{"pagSrc":_vm.badgeSrc,"useScale":true,"scaleMode":3,"autoPlay":true,"loop":0}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }